import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap";
// import "./datatables.scss";
import '../Icons/IconFontawesome';

import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import Modal from './DeleteModal';
import DataTable from 'react-data-table-component';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';

const ByProjectLeads = (props) => {
  const { user, setIsAddForm, setCurrentLead } = props;
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [projects, setProjects] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "Delete" });
  const [projectId, setProjectId] = useState(props?.projectId);

  console.log('props on card on lead', props);

  useEffect(() => {
    if (user?.companyId) {
      getProjects();
      if (projectId) {
        if (user?.role == 'Admin')
          getLeads();
        else
          getLeadsByModer();
      }
    }
  }, [user]);

  useEffect(() => {
    setColumns([
      {
        name: 'Lead Name',
        selector: row => row.name,
      },
      {
        name: 'Client Email',
        selector: row => row.email,
      },
      {
        name: 'Client Mobile',
        selector: row => row.mobile,
      },
      {
        name: 'Description',
        selector: row => row.intro.length > 30 ? row.intro.substring(0, 30) + '...' : row.intro,
      },
      {
        name: 'Project',
        selector: row => row.project.length > 0 ? row.project[0]?.name : ' - ',
      },
      user?.role == 'Admin' &&
      {
        name: 'Assigned Moderator',
        selector: row => row?.moderator.length > 0 ? row?.moderator[0]?.name : ''
      },
      {
        name: 'Assigned Channel Partner',
        selector: row => row?.dealer.length > 0 ? row?.dealer[0]?.name : ''
      },
      // {
      //   cell: (row) => <>
      //     <AvForm style={{ textAlign: 'left' }}>
      //       <AvField onChange={(e) => assignToModerator(row, e.target.value)} style={{ minWidth: 100, padding: 5, paddingLeft: 8, paddingRight: 8 }}
      //         type="select"
      //         name="assignToM"
      //         placeholder="Select Moderator"
      //       >
      //         <option value="">Select Moderator</option>
      //         {moderator.map((item) => {
      //           return <option value={item?._id}>{item.name}</option>
      //         })}
      //       </AvField>
      //     </AvForm>
      //     {/* <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button> */}
      //   </>,
      //   name: 'Assign To',
      //   ignoreRowClick: true,
      //   // allowOverflow: true,
      //   // button: true,
      // },
      {
        cell: (row) => <>
          <Button onClick={() => props?.history.push("/lead/" + row?._id)}
            title={"View"}
            style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button>
          {user?.role == 'Admin' &&
            <Button onClick={() => handleArchivedLead(row)}
              title={"Archive"}
              style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-archive-arrow-down" style={{ fontSize: 20 }}></span></Button>
          }
          {user?.role == 'Admin' || row?.addedBy == user?._id ?
            <Button onClick={() => handleUpdateLead(row)}
              title={"Edit"}
              style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
            : null
          }
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ])
  }, [data]);

  useEffect(() => {
    if (projectId) {
      if (user?.role == 'Admin')
        getLeads();
      else
        getLeadsByModer();
    }
  }, [projectId]);

  const getLeads = async () => {
    get("/lead/list?kind=project&projectId=" + projectId, { token: user?.token })
      .then(json => {
        console.log('response from get lead list', json);
        setData(json?.data);
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const getLeadsByModer = () => {
    get("/lead/list/moderator?kind=project&projectId=" + projectId, { token: user?.token })
      .then(json => {
        console.log('response from get lead list', json);
        setData(json?.data);
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const getProjects = () => {
    get("/project/list?companyId=" + user?.companyId+"&kind=moderator", { token: user?.token })
      .then(json => {
        console.log('response from get user list', json);
        if (json.statusCode == 200) {
          setProjects(json?.data);
        }
      })
      .catch(error => {
        console.log('error while getting user list', error);
      })
  }

  const handleUpdateLead = (item) => {
    console.log('called handleUpdateLead', item);
    setCurrentLead(item);
    setIsAddForm(true);
  }

  const handleArchivedLead = (lead) => {
    console.log('updating lead', lead);
    setModalData({ type: "Archive", lead: lead });
    setIsModal(true);
  }


  const onConfirm = () => {
    let body = {};
    if (modalData?.type == 'Archive') {
      body = { lead_id: modalData?.lead?._id, timeline:[...modalData?.lead?.timeline, {title:'Archived', desc:`Lead Archived by ${user?.name}.`}], status: 'Archived', token: user?.token };
    }
    put("/lead/update", body)
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          toast.success("Success");
          getLeads();
          setIsModal(false);
          setModalData({ type: "Delete" });
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  return (
    <React.Fragment>
      <div className="">
        <Modal
          show={isModal}
          onClick={() => onConfirm()}
          onCloseClick={() => setIsModal(false)}
          data={modalData}
        />
        <Row style={{ marginBottom: 10 }}>
          <Col lg="12">
            <AvForm>
              <AvField
                name="projectId"
                label={"Select Project"}
                value={projectId}
                type="select"
                onChange={(e) => setProjectId(e.target.value)}
              >
                <option value={""} >Select Project</option>
                {projects.map((item) =>
                  <option value={item?._id} key={item?._id}>{item?.name}</option>
                )}
              </AvField>
            </AvForm>
          </Col>
        </Row>
        <DataTable
          columns={columns}
          data={data}
          pagination
          customStyles={{
            headCells: {
              style: {
                color: 'black',
                fontWeight: 'bold',
                fontSize: 15,
                maxWidth: 80
              },
            },
            cells: {
              style: {
                maxWidth: 50
              }
            }
          }}
        />
      </div>
    </React.Fragment>
  )
}

export default ByProjectLeads;
